// extracted by mini-css-extract-plugin
export default {"container-wrapper":"Container_container-wrapper__FnCVe","terms":"Container_terms__1tGg9"};